import type { SessionDto } from '@bnn/shared';

export const STATUS_LABEL: Record<SessionDto['status'], string> = {
  OPEN: 'กำลังนับ',
  REVIEW: 'ตรวจยอด',
  COMPLETED: 'ปิดรอบแล้ว',
  CANCELLED: 'ยกเลิก',
};

export const STATUS_TONE: Record<SessionDto['status'], 'ok' | 'warn' | 'neutral' | 'bad'> = {
  OPEN: 'ok',
  REVIEW: 'warn',
  COMPLETED: 'neutral',
  CANCELLED: 'bad',
};

export const dt = (iso: string | null | undefined) => (iso ? new Date(iso).toLocaleString('th-TH', { dateStyle: 'short', timeStyle: 'short' }) : '-');
export const hm = (iso: string) => new Date(iso).toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' });

/** "12.5000" -> "12.5" for display (string in, string out — never via float). */
export const qty = (s: string | null | undefined) => {
  if (s == null) return '-';
  const [i, f = ''] = s.split('.');
  const frac = f.replace(/0+$/, '');
  return Number(i).toLocaleString('en-US') + (frac ? '.' + frac : '');
};
